import classNames from 'classnames';
import ProjectBadge from 'components/projects/ProjectBadge';
import React from 'react';
import type { TicMeta } from 'types/tic';
import styles from './ForecastStateIndicator.module.scss';

interface Props {
  isComplete?: boolean;
  color?: string;
  ticMeta?: TicMeta;
}

/**
 * Provides the indent often needed on "sub table rows", and Task icon
 */
export const ForecastStateIndicator: React.FC<Props> = ({ color, isComplete, ticMeta }) => {
  const containerClass = classNames(styles.stateContainer, {
    [styles.completed]: isComplete,
  });
  return (
    <span className={containerClass}>
      <ProjectBadge icon="task" size="small" color={color ?? '#ccc'} ticMeta={ticMeta} />
    </span>
  );
};

export default ForecastStateIndicator;
